import TileLayer from "ol/layer/Tile";
import {ImageArcGISRest, ImageWMS, TileArcGISRest, TileWMS} from "ol/source";
import {transformExtent, transform, get as getProjection} from "ol/proj";
import {callService} from "@/helpers/ol/ol-http-helper";
import ImageLayer from "ol/layer/Image";
import {
    getActiveLayers,
    getLayerAttributes, getLayerByName,
    getLayerNamePrefix,
    removeLoaderByBookmarkPresentationID, updateBookmarkPresentationByID, updateLayerSourceParams
} from "@/helpers/ol/ol-layer-helper";
import {Point} from "ol/geom";
import {getOlRotation} from "@/helpers/ol/ol-rotation-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import TileState from "ol/TileState";
import {getBySelector, hideElementsBySelector} from "@/helpers/element-helper";

import {
    getLatLonProjectionName, getViewProjection,
    getViewProjectionByName,
    getViewProjectionName
} from "@/helpers/ol/ol-projection-helper";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import TileGrid from "ol/tilegrid/TileGrid";
import {getTopLeft, getWidth} from "ol/extent";
import {getTileGridByProjection} from "@/modules/ol/service/ol-service-wmts";
import {getOgcInFilter} from "@/helpers/filter/filter-ogc-helper";
import {hasLayerDomainList} from "@/helpers/layer/overview/layer-overview-domain-list-helper";
import {getActiveFilter} from "@/helpers/filter/filter-helper";
import {getLegendUrlByBookmarkPresentation, updateInfoLegends} from "@/helpers/layer/info/layer-info-legend-helper.js";
import {showNotification} from "@/helpers/notification-helper.js";
import {scaleToResolution} from "@/helpers/ol/view/ol-view-resolutation-helper.js";

let token
/**
 * Add Web Map Service
 * @param map
 * @param service
 */
export function addServiceWms(map, service) {

    let serviceUrl = service.Url

    const projection = getViewProjection()

    // console.log(projection)
    try {
        new URL(serviceUrl);
    } catch (_) {
        serviceUrl = window.kaartViewerUrl + serviceUrl
    }

    let styles = service.Styles
    if(Array.isArray(styles)) {
        styles = styles[0]
    }
    token = getToken()

    if(window.urlParamsObject.stijl) {
        let urlStyles = window.urlParamsObject.stijl.split(',')
        window.urlParamsObject.bookmarkpresentatieids.split(',').map((id, key) => {
            if (service.id === id) {
                styles = urlStyles[key]
                if (styles) {
                    setTimeout(() => {
                        updateBookmarkPresentationByID(parseInt(service.id), 'StyleActive', styles)
                    })
                }
            }
        })
    }

    let source = {
        url: serviceUrl,
        params: {
            'LAYERS': service.Layer,
            STYLES: styles,
            TRANSPARENT: 'true'
        },
        projection: service.Service.Projection,
        ratio: 1,
        attributions: getLayerAttributes(service)
    }

    removeLoaderByBookmarkPresentationID(service.id)

    let extent = service.Extent
    if(!extent) {
        extent = projection.getExtent()
    }

    if(service.Filter && service.Filter.Filter) {
        if(service.Service.Proxy === 0) {
            source.params['FILTER'] = '<Filter xmlns:ogc="http://www.opengis.net/ogc">' + service.Filter.Filter + '</Filter>'
        } else {
            source.params['FILTER'] = service.Filter.Filter
        }
    }

    let layer
    if(service.Untiled) {
        if(serviceUrl.includes('/map?')){
            source.imageLoadFunction = (tile, src) => {
                loadFunction(tile, src)
            }
        }
        source = new ImageWMS(source)
    } else {
        if(serviceUrl.includes('/map?')){
            // Check if auth works
            source.tileLoadFunction = (tile, src) => {
                loadFunction(tile, src)
            }
        }

        // Check if tilelodad cu

        source.tileGrid = new TileGrid(getTileGridByProjection(getViewProjectionByName(service.Service.Projection)))
        source = new TileWMS(source)
    }

    source.set('olcs_projection', getProjection('EPSG:3857'))

    if(service.Opacity === undefined) {
        service.Opacity = 10
    }

    const layerOptions = {
        minResolution: scaleToResolution(service.MinResolution),
        maxResolution: scaleToResolution(service.MaxResolution),
        extent: extent,
        name: getLayerNamePrefix() + service.id,
        opacity: service.Opacity / 10,
        zIndex: service.zIndex,
        source: source
    }

    console.log(layerOptions)

    // Set layer
    if(service.Untiled) {
        layer = new ImageLayer(layerOptions)
    } else {
        layer = new TileLayer(layerOptions)
    }

    if(service.Interval) {
        setInterval(() => {
            layer.getSource().refresh();
        }, service.Interval * 1000)
    }

    map.addLayer(layer)

    source.on(['imageloaderror'], function () {
        // showNotification('Laag ' + service.DisplayName + ' kan niet geladen worden. Neem contact op met de beheerder.', '', 'warning')
    });

    console.log('add layer')

    return layer
}

/**
 * Add service WMS by url
 * @param map
 * @param url
 * @param layer
 * @param opacity
 */
export function addServiceWmsByUrl(map, url, layer, opacity) {

    const projection = getViewProjection()
    const extent = projection.getExtent()

    map.addLayer( new TileLayer( {
        extent: extent,
        // name: getLayerNamePrefix() + service.id,
        name: layer,
        opacity: opacity,
        source: new TileWMS({
            url: url,
            params: {
                'LAYERS': layer,
                TRANSPARENT: 'true'
            },
            projection: getViewProjectionName(),
            ratio: 1
        })
    }))
}

/**
 * Display feature info 2D
 * @param pixel
 * @param coordinate
 */
export function displayFeatureInfo(pixel,coordinate) {

    if(getOlRotation() === 0) {
        const layersActive = getActiveLayers()

        if(layersActive[0]) {
            // const destinationProjection = layersActive[0].Service.Projection
            const destinationProjection = getViewProjectionName()

            const result = transform([coordinate[0], coordinate[1]], getViewProjectionName(), destinationProjection)
            const size = window.map.getSize()
            const extent = new transformExtent(window.map.getView().calculateExtent(map.getSize()), getViewProjectionName(), destinationProjection)

            const wmsGetFeatureInfo = {}
            wmsGetFeatureInfo.width = size[0]
            wmsGetFeatureInfo.height = size[1]

            wmsGetFeatureInfo.I = Math.round(pixel[0])
            wmsGetFeatureInfo.J = Math.round(pixel[1])

            wmsGetFeatureInfo.x = result[0]
            wmsGetFeatureInfo.y = result[1]

            if (destinationProjection === getLatLonProjectionName()) {
                wmsGetFeatureInfo.extent = extent[1] + ',' + extent[0] + ',' + extent[3] + ',' + extent[2]
            } else {
                wmsGetFeatureInfo.extent = extent.join(',')
            }
            wmsGetFeatureInfo.isMobile = "1"

            wmsGetFeatureInfo.info_objects = []

            layersActive.map((layerActive) => {
                const layer = getLayerByName(layerActive.BookmarkPresentationID)
                if(layerActive.Forms?.length > 0 && layer && layer.isVisible()) {

                    let filter = layerActive.Filter.Filter
                    if(hasLayerDomainList(layerActive) && layerActive.WfsStyle.attribute) {
                        filter = getOgcInFilter(layerActive.BookmarkPresentationID, layerActive.WfsStyle.attribute)
                    }

                    const activeFilter = getActiveFilter()
                    if(activeFilter) {
                        const checkBox = getBySelector('#chbFilterMark')
                        if(activeFilter.BookmarkPresentationID === layerActive.BookmarkPresentationID && checkBox && !checkBox.checked ) {
                            filter = window.filterTableFilter
                        }
                    }

                    wmsGetFeatureInfo.info_objects.push({
                        layerid: layerActive.BookmarkPresentationID,
                        filter: filter,
                        extent: new transformExtent(window.map.getView().calculateExtent(map.getSize()), getViewProjectionName(), layerActive.Service.Projection).join(',')
                    })
                }
            })

            if(wmsGetFeatureInfo.info_objects.length > 0 || (layersActive[0] instanceof String && layersActive[0]?.includes('temporary-'))) {
                callService(wmsGetFeatureInfo?.info_objects[0]?.layerid, wmsGetFeatureInfo, 'wms', undefined, undefined, undefined, coordinate)
            }
        }
    }  else {
        const result = transform([coordinate[0], coordinate[1]], getViewProjectionName(), getLatLonProjectionName())
        displayFeatureInfo3D(result[1], result[0])
    }
}

/**
 * Display feature info 3D
 * @param lat
 * @param lon
 */
export function displayFeatureInfo3D(lat, lon) {

    const layersActive = getActiveLayers()
    if(layersActive[0]) {
        const destinationProjection = layersActive[0].Service.Projection

        const extentLatLon = new transformExtent(window.map.getView().calculateExtent(map.getSize()), getViewProjectionName(), getViewProjectionName())

        let heightLon = (extentLatLon[3] - extentLatLon[1]) / 2

        const xy = new Point([lon, lat]).transform(getLatLonProjectionName(), getViewProjectionName())

        const x = xy.getCoordinates()[0]
        const y = xy.getCoordinates()[1]

        let extent =
            (x-heightLon).toFixed(6).toString() + ',' +
            (y-heightLon).toFixed(6).toString() + ',' +
            (x+heightLon).toFixed(6).toString() + ',' +
            (y+heightLon).toFixed(6).toString();

        const wmsGetFeatureInfo = {}

        wmsGetFeatureInfo.width = 1000
        wmsGetFeatureInfo.height = 1000

        wmsGetFeatureInfo.I = 500
        wmsGetFeatureInfo.J = 500

        wmsGetFeatureInfo.x = 500
        wmsGetFeatureInfo.y = 500

        wmsGetFeatureInfo.extent = extent

        wmsGetFeatureInfo.isMobile = "1"

        wmsGetFeatureInfo.info_objects = []
        layersActive.map((layerActive) => {
            if(layerActive.Forms.length > 0) {
                wmsGetFeatureInfo.info_objects.push({
                    layerid: layerActive.BookmarkPresentationID,
                    filter: layerActive.Filter.Filter
                })
            }
        })

        if(wmsGetFeatureInfo.info_objects.length > 0) {
            callService(window.layersActive[0], wmsGetFeatureInfo, 'wms')
        }
    }
}

/**
 * Load function
 * @param tile
 * @param src
 */
export function loadFunction(tile, src) {
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.addEventListener('loadend', function () {
        const data = this.response;
        if (data !== undefined) {
            tile.getImage().src = URL.createObjectURL(data);
        } else {
            tile.setState(TileState.ERROR);
        }
    });
    xhr.addEventListener('error', function () {
        tile.setState(TileState.ERROR);
    });
    xhr.open('GET', src);
    if(getToken() !== undefined) {
        xhr.setRequestHeader("Authorization", getToken());
    }
    xhr.send();
}
